import { tv } from "tailwind-variants";

import { monsterrat } from "@/services/styles/fonts";

export const getHeadingClass = tv({ base: ["font-semibold text-xl lg:text-4xl", monsterrat.className] });

export const getStepClass = tv({
  base: ["flex-1", "animate-duration-300! group-[.animate-intersected-in]/intersected:animate-fade-up"],
});

export const getAnnotationClass = tv({
  base: [
    "mt-1 flex items-center gap-2 font-semibold text-[11px] text-detail-600 lg:text-xs lg:leading-relaxed",
    monsterrat.className,
  ],
});
